import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("jps_cart") || "[]");
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("jps_cart", JSON.stringify(items));
  }, [items]);

  const addItem = useCallback((product, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.slug === product.slug);
      if (found) {
        return prev.map((i) => (i.slug === product.slug ? { ...i, quantity: i.quantity + qty } : i));
      }
      return [
        ...prev,
        { product_id: product.id, slug: product.slug, name: product.name, price: product.price, image: product.image, quantity: qty },
      ];
    });
    setOpen(true);
  }, []);

  const removeItem = useCallback((slug) => setItems((prev) => prev.filter((i) => i.slug !== slug)), []);

  const updateQty = useCallback((slug, qty) => {
    if (qty <= 0) return removeItem(slug);
    setItems((prev) => prev.map((i) => (i.slug === slug ? { ...i, quantity: qty } : i)));
  }, [removeItem]);

  const clear = useCallback(() => setItems([]), []);

  const count = useMemo(() => items.reduce((s, i) => s + i.quantity, 0), [items]);
  const subtotal = useMemo(() => items.reduce((s, i) => s + i.price * i.quantity, 0), [items]);

  const value = useMemo(
    () => ({ items, open, setOpen, addItem, updateQty, removeItem, clear, count, subtotal }),
    [items, open, addItem, updateQty, removeItem, clear, count, subtotal]
  );

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

export const useCart = () => useContext(CartContext);
